import { ChatbotApiCaller } from '@frontend/api'

import { setAccessToken } from './storage'

export async function authenticate(chatId: string) {
	const token = new URLSearchParams(window.location.search).get('access_token') as string | undefined
	const preview = Boolean(new URLSearchParams(window.location.search).get('preview') as string | undefined)

	let response

	if (preview && token) {
		response = await ChatbotApiCaller.authenticatePreview(chatId, token)
	} else {
		response = await ChatbotApiCaller.authenticate(chatId)
	}

	const { accessToken } = response

	setAccessToken(chatId, accessToken, preview)

	return {
		accessToken
	}
}
